import httpClient from '~/http';
import { PermissionItem } from '~/types/permission';
import { RoleFormValues, RoleItem } from '../types';

const fetchPermissions = () => {
  return httpClient.get<{ permissions: PermissionItem[] }>(
    '/api/v2/permissions'
  );
};

const createRole = (values: RoleFormValues) => {
  return httpClient.post('/api/v2/restaurant-roles', values);
};

const updateRole = (id: string, values: RoleFormValues) => {
  return httpClient.put(`/api/v2/restaurant-roles/${id}`, values);
};

const getRole = (id: string) => {
  return httpClient
    .get<{ restaurantRoles: RoleItem[] }>('/api/v2/restaurant-roles', {
      params: { restaurantRoleId: id },
    })
    .then(({ restaurantRoles }) => restaurantRoles[0]);
};

const getManyRole = () => {
  return httpClient
    .get<{ restaurantRoles: RoleItem[] }>('/api/v2/restaurant-roles')
    .then(({ restaurantRoles }) => restaurantRoles);
};

export default {
  createRole,
  getRole,
  updateRole,
  getManyRole,
  fetchPermissions,
};
